export enum LaunchMessages {
  "pt-br" = "pt-br",
  "es" = "es",
  "hu" = "hu",
}
